import React, { useEffect ,useState } from 'react';
import LeftView from './components/LeftView';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { v4 as uuid } from "uuid";
import { useSelector } from 'react-redux';
import { fetchCompaniesUrl } from '../../Library/URLs';
import Config from './Config';
import "../../Assets/Scss/Configuration.scss";

const PageContain = () => {
	const { companyid } = useParams(); 
	const [company, setCompany] = useState({});
	const User = useSelector((state) => state.payroll?.User);
  const [isLoading, setIsLoading] = useState(false);
  const unique_id = uuid();

	const FetchAllCompanies = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: User.company_id,
    };
    setIsLoading(true);
    await axios
      .post(fetchCompaniesUrl, data)
      .then((res) => {
        setIsLoading(false);
        if (res.data) {
          setCompany(res.data?.data?.find(item => item?.id===companyid));
          // console.log('all depart',res.data)
        }
        // console.log('all department res',res.data)
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
        setIsLoading(false);
      });
  };

	useEffect(() => {
		FetchAllCompanies();
		// eslint-disable-next-line
	},[])

	return (
		<div className='Config_wrap' >
			<div className="Header">
				<h2>Company Configuration</h2>
			</div>
			<div className="Details_Wrapper">
				<div className="LeftView">
					<LeftView company={company} />
				</div>
				<div className="RightView">
					<Config />
				</div>
			</div>
		</div>
	)
}

export default PageContain